@if (currentPage?.isWizardVisible) {
    <div class="flex items-center gap-4">
        <big-ui-chart-circular-progress-bar
            [size]="52"
            [angle]="(360 * nodeIndex) / wizardPageCount"
            [colorMap]="{ primarySpan: { min: 0, max: 360 } }"
            class="text-[12px] font-semibold leading-[1.6]">
            @if (nodeIndex !== wizardPageCount) {
                <span class="text-primary dark:text-white">{{ nodeIndex }}/{{ wizardPageCount }}</span>
            } @else {
                <big-icon
                    [icon]="iconOk"
                    [size]="'w-5'"
                    class="fill-success-600 dark:fill-success-400 mx-auto" />
            }
        </big-ui-chart-circular-progress-bar>
        <span class="text-sm font-normal leading-[1.6] text-primary-800 dark:text-primary-50">
            {{ mobileWizardLabel | replaceTokenRef: currentPage?.settings?.arrayParents }}
        </span>
    </div>
}
